import Image from 'app/Components/Shared/Image/image';
import React, {ChangeEvent, useState, useRef, useEffect} from 'react';
import useOnClickOutside from 'app/utilities/hooks/useOnClickOutside';
import multiHighlightText from '../TheCounterPage/multiHighlightText';
import classNames from 'classnames';
import ProviderManager from '../../../provider/providerManager';
import ServiceCenter from './ServiceCenter.js';
export interface ServiceCentersSearchItem {
  name: string;
  hints: string;
  href: string;
}

const ServiceCentersSearch = ({placeholder, isIdf, onSelectChange, selectedCenter}) => {
  const ref = useRef();
  const [outside, setOutside] = useState(false);
  const [term, setTerm] = useState('');
  const [cities, setCities] = useState<string[] | null>(null);
  const [centers, setCenters] = useState<any[] | null>(null);
  const isIdfFlag = isIdf ? true : false;
  useOnClickOutside(ref, (outside) => setOutside(outside));


  useEffect(() => {
    term.length >= 2 &&
      ProviderManager.getProviderData('getCitiesByValue', [term]).then((data) => {
        const results = /^\s*$/.test(term) ? null : data.Body;
        setCities(results?.map((d) => d.municipalname));
      });
  }, [term]);


  const clearTerm = () => {
    setTerm('');
    setCities(null);
    setCenters(null);
  };

  const changeTerm = (event: ChangeEvent<HTMLInputElement>) => {
    setTerm(event.target.value);
    setCenters(null);
  };

  async function selectCity(city) {
    setTerm(city);
    setOutside(true);
    setCities(null);
    let nearByCenters;
    await ProviderManager.getProviderData('getServiceCenteresNearBy', [city]).then((data) => {
      nearByCenters = data.Body;
    });

    setCenters(nearByCenters);
  }

  const isDinamica = () => {
    let isInclude = false;
    centers.map(function (item, index) {
      if (item?.siteDesc?.includes('דינמיקה')) {
        isInclude = true;
      }
    });
    return isInclude;
  };

  const showDinamicaRemark = () => {
    if (centers != undefined) {
      if (isDinamica()) {
        return (
          <div className='dinamica_remark'>
            <p>
              *לתשומת לבכם, בסניפי דינמיקה לא ניתן לבצע את הפעולות הבאות: החזרה/ הוספה/שדרוג ציוד סלקום TV, רכישה/החזרת דונגל, סלקום דו,
              ביטול עסקה, גביית חוב, איסוף סים.
            </p>
            <p>הגבלות אלו לא חלות על סניפי דינמיקה+ (פלוס), וניתן לבצע בהם את כל הפעולות למעט ניתוק שירותי אינטרנט.</p>
          </div>
        );
      }
    }
  };

  return (
    <div className={classNames('ServiceCentersSearch', {term})} ref={ref}>
      <div className='ServiceCentersSearch__placeholder'>{placeholder}</div>
      <Image className='ServiceCentersSearch__reset' onClick={clearTerm} src={require('./images/reset.svg')} />
      <input placeholder={placeholder} type='text' value={term} onChange={changeTerm} />
      {cities != null && !outside && (
        <div className='ServiceCentersSearch__results'>
          <ul>
            {cities.map((city, index) => (
              <li key={index}>
                <div className='city' onClick={() => selectCity(city)}>
                  {multiHighlightText({text: city, term})}
                </div>
              </li>
            ))}
            {cities.length == 0 && <li>מצטערים, לא מצאנו מרכז שירות בעיר זו. אנא נסו עיר אחרת</li>}
          </ul>
        </div>
      )}
      {centers != null && (
        <div className={`ServiceCentersSearch__centers${isIdfFlag ? ' isIdf' : ''}`}>
          {centers.map((center, i) =>
            !isIdfFlag ? (
              <ServiceCenter key={i} center={center} isIdf={false} />
            ) : (
              i < 5 && (
                <>
                  <div className={`position-relative mb-2 ${center === selectedCenter ? 'selected' : ''}`}>
                    <ServiceCenter key={i} center={center} isIdf={isIdfFlag} />
                    {/* {isIdfFlag && (
                      <input
                        type='radio'
                        name='serviceCenter'
                        value={i}
                        onClick={(e) => onSelectChange(center)}
                        className='service-center-selector position-absolute '></input>
                    )} */}
                  </div>
                </>
              )
            ),
          )}
        </div>
      )}
    </div>
  );
};

export default ServiceCentersSearch;
